import React from 'react';
import { useHistory } from 'react-router-dom';

import BaseLayout from '~/pages/_layouts/base';

import Button from '~/components/Button';
import { Container } from './styles';

export default function Errors() {
  const history = useHistory();
  return (
    <BaseLayout>
      <Container>
        <div className="error-code">404</div>
        <h1>404</h1>
        <h2>Página não encontrada</h2>

        <Button onClick={() => history.push('/')} color="primary">
          Voltar para Home
        </Button>
      </Container>
    </BaseLayout>
  );
}
